import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-slider__pagination flex al-center abs" }
const _hoisted_2 = { class: "main-slider__pagination--inner rel ov-hidden" }

import { computed, ref, onMounted, onUnmounted, watch } from "vue";
import type { Ref } from "vue";
import Bullet from "../UI/MainSlider.paginationTitle.vue";
import clearTimeoutHandler from "@/composables/clearTimeoutHandler";
import { handleResize } from "@/composables/resizeHandler";
import { navigateTo } from "@/composables/navigateTo";
import { useRouter } from "vue-router";



export default /*#__PURE__*/_defineComponent({
  props: {
    isMountedStepTwo: { type: Boolean },
    isMountedStepThree: { type: Boolean },
    showTeaserBar: { type: Boolean },
    direction: null,
    content: null
  },
  emits: ["activeIndex", "prevIndex", "slideChange", "isTransitioningStepOne", "isTransitioningStepTwo"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'activeIndex', idx: number): void
  (e: 'prevIndex', idx: number): void
  (e: 'slideChange', state: boolean): void
  (e: 'isTransitioningStepOne', state: boolean): void
  (e: 'isTransitioningStepTwo', state: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isMountedStepTwo: boolean;
  isMountedStepThree: boolean;
  showTeaserBar: boolean;
  direction: string | null;
  content: {
    trueIndex?: number;
    title: string;
    teaser: string;
    link: {
      title: string;
      url?: string;
    }
  }[]
}

/**
 * @author Irakli Kandelaki
 */

// IMPORTS
const router = useRouter();


// PROPS


// EMITS



// RESIZE HANDLERS
const { windowWidth, windowHeight } = handleResize();



// REFS
const activeIndex = ref(0);
const prevIndex = ref(props.content.length - 1);
const hasInteracted = ref(false);
const middleContentCopy = ref([]);
const listOverflows = ref(false);
const isAutoPlayTriggered = ref(false);
const autoPlayKey = ref(0);
const isTransitioningStepTwoRef = ref(false);
const teaserTyped = ref('');
const teaserTypedCounter = ref(0);
const teaserFadeOut = ref(false);
const nextSlide = ref(1);



// DOM ELEMENTS
let mainSliderTarget: null | HTMLElement = null;




// REFS - TIMEOUTS
const changeSlideStepOneTO: Ref<number | null> = ref(null);
const changeSlideStepTwoTO: Ref<number | null> = ref(null);
const teaserTypingMachineTO: Ref<number | null> = ref(null);

// REFS - INTERVALS
const autoPlayInterval: Ref<number | null> = ref(null);


// LIFECYCLE HOOKS - MOUNTED
onMounted(() => {
  window.setTimeout(() => {
    setBoundaries();
    mainSliderTarget = document.querySelector<HTMLElement>(".main-slider__inner");
    mainSliderTarget.addEventListener('click', handleMouseClick)
  }, 500);

  leftContent.value;
});


// LIFECYCLE HOOKS - UNMOUNTED
onUnmounted(() => {
  clearTimeoutHandler(changeSlideStepOneTO.value);
  clearTimeoutHandler(changeSlideStepTwoTO.value);
  clearTimeoutHandler(teaserTypingMachineTO.value);
  clearInterval(autoPlayInterval.value);
});

// COMPUTED
const trueIndexContent = computed(() => {
  const contentCopy = [...props.content];

  contentCopy.forEach((c, index) => {
    c.trueIndex = index;
  });
  middleContentCopy.value = contentCopy;
  return contentCopy;
});

const middleContent = computed((): {
  trueIndex?: number;
  title: string;
}[] => {
  if (!hasInteracted.value) {
    return middleContentCopy.value;
  } else {
    const activeElement = middleContentCopy.value.filter(
      (c) => c.trueIndex === activeIndex.value
    )[0];
    const prevElement = middleContentCopy.value.filter(
      (c) => c.trueIndex === prevIndex.value
    )[0];
    middleContentCopy.value = middleContentCopy.value.filter(
      (c) => c.trueIndex !== activeIndex.value && c.trueIndex !== prevIndex.value
    );

    middleContentCopy.value.unshift(activeElement);
    middleContentCopy.value.push(prevElement);
    return middleContentCopy.value;
  }
});

const leftContent = computed(() => {
  const contentCopy = [...trueIndexContent.value];
  if (!hasInteracted.value) {
    return contentCopy;
  } else {
    const filteredByPrevIndex = contentCopy.filter(
      (c) => c.trueIndex !== prevIndex.value
    );
    const removedPrevIndex = contentCopy.filter(
      (c) => c.trueIndex === prevIndex.value
    )[0];
    filteredByPrevIndex.push(removedPrevIndex);
    return filteredByPrevIndex;
  }
});




// METHODS
const setActiveIndex = (idx: number) => {
  clearTimeoutHandler(changeSlideStepOneTO.value);
  clearTimeoutHandler(changeSlideStepTwoTO.value);
  teaserFadeOut.value = true;


  autoPlayKey.value += 1;

  handleAutoPlayClear();
  autoPlayInterval.value = window.setInterval(() => {
    handleAutoPlayStart();
  }, 6000)

  hasInteracted.value = true;
  emit('slideChange', true);
  emit('isTransitioningStepOne', true);


  changeSlideStepOneTO.value = window.setTimeout(() => {

    prevIndex.value = activeIndex.value;
    activeIndex.value = idx;
    isTransitioningStepTwoRef.value = true;
    teaserTyped.value = '';
    teaserTypedCounter.value = 0;
    clearTimeout(teaserTypingMachineTO.value);
    typingMachine(props.content[activeIndex.value].teaser, 30);


    emit('isTransitioningStepTwo', true);

    emit('prevIndex', prevIndex.value);
    emit('activeIndex', activeIndex.value);

  }, 500);
  changeSlideStepTwoTO.value = window.setTimeout(() => {
    teaserFadeOut.value = false;

    emit('isTransitioningStepOne', false);
    emit('isTransitioningStepTwo', false);
    isTransitioningStepTwoRef.value = false;
    emit('slideChange', false);



  }, 2050);
};

const setBoundaries = () => {
  const rightCol = document.querySelector<HTMLElement>(".main-slider__pagination--right-block");
  const parentCol = document.querySelector<HTMLElement>(".main-slider__pagination--inner");

  const limitWidth =
    parentCol.clientWidth -
    Math.abs(
      parentCol.getBoundingClientRect().left - rightCol.getBoundingClientRect().left
    );
  if (rightCol.clientWidth > limitWidth) listOverflows.value = true;
};

const handleAutoPlayStart = () => {
  isAutoPlayTriggered.value = false;
  const nextSlide: number = activeIndex.value === props.content.length - 1 ? 0 : activeIndex.value + 1;
  setActiveIndex(nextSlide);
  isAutoPlayTriggered.value = true;
}

const handleAutoPlayClear = () => {
  if (autoPlayInterval.value === null) return;

  clearInterval(autoPlayInterval.value);
}

const handleSlideChangeBySwipe = () => {
  if (isTransitioningStepTwoRef.value || !props.isMountedStepThree) return;

  if (props.direction === 'RIGHT') {
    nextSlide.value = activeIndex.value === props.content.length - 1 ? 0 : activeIndex.value + 1;

  } else {
    nextSlide.value = activeIndex.value === 0 ? props.content.length - 1 : activeIndex.value - 1;

  }

  setActiveIndex(nextSlide.value);

}


const handleMouseClick = (e: MouseEvent) => {
  if (isTransitioningStepTwoRef.value || !props.isMountedStepThree) return;

  const nextSlide: number = activeIndex.value === props.content.length - 1 ? 0 : activeIndex.value + 1;
  const prevSlide: number = activeIndex.value === 0 ? props.content.length - 1 : activeIndex.value - 1;

  if (e.clientX > mainSliderTarget.offsetWidth * 0.8) {


    setActiveIndex(nextSlide);

  }
  if (e.clientX < mainSliderTarget.offsetWidth * 0.2) {

    setActiveIndex(prevSlide);

  }

  if (e.clientX >= mainSliderTarget.offsetWidth * 0.2 &&
    e.clientX <= mainSliderTarget.offsetWidth * 0.8) {
    navigateTo(router, props.content[activeIndex.value]?.link?.url);
  }
}

// TYPING MACHINES


const typingMachine = (targetVal: string, speed: number): void => {
  if (teaserTypedCounter.value < targetVal.length) {
    teaserTyped.value += targetVal.charAt(teaserTypedCounter.value);
    teaserTypedCounter.value += 1;
    teaserTypingMachineTO.value = window.setTimeout(() => {
      typingMachine(targetVal, speed)
    }, speed);

  }


}


// WATCHERS
watch(() => props.isMountedStepTwo, (ns) => {
  if (!ns) return;
  handleAutoPlayClear();
  isAutoPlayTriggered.value = true;

  autoPlayInterval.value = window.setInterval(() => {
    handleAutoPlayStart();
  }, 8000)
})

watch(() => props.isMountedStepThree, (ns) => {
  if (!ns) return;
  teaserTyped.value = '';
  teaserTypedCounter.value = 0;
  typingMachine(props.content[activeIndex.value].teaser, 50);
})

// WATCHERS
watch(() => props.direction, (ns) => {
  if (ns === null) return;
  handleSlideChangeBySwipe();

})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-slider__pagination--teaser main-slider-container abs ov-hidden", { 'show-teaser-bar': __props.showTeaserBar }]),
      style: _normalizeStyle({ top: _unref(windowWidth) <= 1023 ? _unref(windowHeight) - 190 + 'px' : '' })
    }, [
      (__props.isMountedStepThree)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["uppercase highlight regular fira c-white wc-lg clamp-2", { 'teaser-fade-out': teaserFadeOut.value }])
          }, [
            _createElementVNode("span", null, _toDisplayString(teaserTyped.value), 1)
          ], 2))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["main-slider__pagination--progress abs bg-t-red", { 'started': isAutoPlayTriggered.value }]),
        key: autoPlayKey.value
      }, null, 2)),
      _createElementVNode("div", _hoisted_2, [
        (listOverflows.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "main-slider__pagination--left-block",
              style: _normalizeStyle({ 'pointer-events': isTransitioningStepTwoRef.value || !__props.isMountedStepThree ? 'none' : 'all' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftContent), (bullet, index) => {
                return (_openBlock(), _createBlock(Bullet, {
                  title: bullet?.title,
                  key: index,
                  index: index,
                  onClick: ($event: any) => (setActiveIndex(bullet?.trueIndex))
                }, null, 8, ["title", "index", "onClick"]))
              }), 128))
            ], 4))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "main-slider__pagination--right-block",
          style: _normalizeStyle({ 'pointer-events': isTransitioningStepTwoRef.value || !__props.isMountedStepThree ? 'none' : 'all' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(middleContent), (bullet, index) => {
            return (_openBlock(), _createBlock(Bullet, {
              title: bullet?.title,
              key: index,
              index: index,
              onClick: ($event: any) => (setActiveIndex(bullet?.trueIndex)),
              isTransitioningStepTwo: isTransitioningStepTwoRef.value,
              class: _normalizeClass({ 'main-slider__pagination--active': bullet?.trueIndex === activeIndex.value })
            }, null, 8, ["title", "index", "onClick", "isTransitioningStepTwo", "class"]))
          }), 128))
        ], 4)
      ])
    ])
  ], 64))
}
}

})